import { createFileRoute } from "@tanstack/react-router";
import { CasePage } from "../../../components/cases/case-page";

/** One case's page: its thread beside its steps. Keyed by case, so nothing carries across. */
export const Route = createFileRoute("/_authenticated/_workspace/cases/$caseId")({
  component: function CaseRoute() {
    const { caseId } = Route.useParams();
    return <CasePage key={caseId} caseId={caseId} />;
  },
});
